


















































































































































































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";

@Component({
  name: "independentLandmark",
})
export default class extends Vue {
  private bottomShowType: any = true;

  @Prop()
  inputPageHomeData: any;

  private homeData: any = null;

  private landmarkColumn: any = null;

  private landmarkIndex: any = 0;

  // 底部地标文章索引
  private landmarkArtucleIndex: any = 0;

  @Watch("inputPageHomeData", { immediate: true, deep: true })
  oninputPageHomeData(val: any, oldVal: any) {
    if (val) {
      this.homeData = val.pageHome;
      this.landmarkColumn = val.landmarkColumn;
      // console.log('inputPageHomeData-------------ssss-',val)
    }
    // this.pageHomeData = val;
    // this.designatedArticleListData =  val.designatedArticleList[0].article_list.article_list;
  }

  private dialogShow: any = false;
  private videoUrl: any = "";

  private vrdialogShow: any = false;
  private vrUrl: any = "";

  private showVideo(url: any) {
    this.videoUrl = url;
    this.dialogShow = true;
    // console.log(url)
  }

  private showVr(url: any) {
    this.vrUrl = url;
    this.vrdialogShow = true;
    // console.log(url)
  }

  private tabLandmarkArtucleIndex(index: any) {
    this.landmarkArtucleIndex = index;
  }

  private toArticleList(id: any, item: any = null) {
    if (item != null) {
      // console.log('item----',item.name)
      if (item.name == "智慧展示" || item.name == "宣传视频") {
        return false;
      } else {
        this.$router.push({
          name: "Article",
          query: {
            type: "0",
            id,
          },
        });
      }
    } else {
      this.$router.push({
        name: "Article",
        query: {
          type: "0",
          id,
        },
      });
    }
  }

  private toDetail(item: any) {
    this.$router.push({
      name: "Article",
      query: {
        type: "1",
        landmarkId: item.landmark_id,
        id: item.id,
      },
    });
  }
}
